module.exports = __webpack_public_path__ + "img/language-symbol.882ae306.svg";